import React from 'react';
import styles from './page2.scss';
import pic from './pic.png';

function Page2(props) {
  return (
    <div className={styles['page2']} ref={props.myRef}>
      <div className={styles['page2-main']}>
        <div className={`${styles['page2-title']} animate2-wrapper`}>
          <div r='214' g='225' b='227' className={`maskBlock animate2`} style={{ background: 'rgb(214, 225, 227)' }} />
          OUT PARTNERS
        </div>

        <div className={styles['page2-title-subTitle']}>
          <div className={styles['page2-title-subTitle-num']}>2</div>
          <div className={styles['page2-title-subTitle-text']}>服务客户</div>
        </div>

        <div className={styles['page2-pic']}>
          <img src={pic} />
        </div>
      </div>
    </div>
  );
}

export default Page2;